import { TESTIMONIALS, BUSINESS } from "#/lib/constants";
import { SectionLabel } from "#/components/shared/SectionLabel";
import { CTAButton } from "#/components/shared/CTAButton";
import { useScrollAnimation } from "#/hooks/useScrollAnimation";
import { Star, Quote } from "lucide-react";

export function Testimonials() {
  const { ref, isVisible } = useScrollAnimation(0.05);

  return (
    <section id="reviews" className="bg-white py-20 lg:py-28">
      <div ref={ref} className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-2xl">
          <SectionLabel>Reviews</SectionLabel>
          <h2
            className={`mt-4 font-heading text-3xl font-extrabold leading-[1.1] text-graphite transition-all duration-700 sm:text-4xl lg:text-5xl ${
              isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
            }`}
          >
            Delaware homeowners don't mince words.
          </h2>
        </div>

        {/* Cards */}
        <div className="mt-12 grid gap-5 md:grid-cols-2">
          {TESTIMONIALS.slice(0, 2).map((t, i) => (
            <figure
              key={t.name}
              className={`relative flex flex-col rounded-2xl border border-gray-200 bg-white p-6 transition-all duration-500 hover:border-flame/30 hover:shadow-lg hover:shadow-flame/5 ${
                isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
              }`}
              style={{ transitionDelay: isVisible ? `${i * 80}ms` : "0ms" }}
            >
              <Quote className="absolute right-6 top-6 h-8 w-8 text-flame/15" />
              <div className="flex">
                {[...Array(t.rating)].map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-flame text-flame" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-graphite">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-gray-100 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-graphite text-sm font-bold text-white">
                  {t.name.charAt(0)}
                </span>
                <div>
                  <p className="text-sm font-bold text-graphite">{t.name}</p>
                  <p className="text-xs text-concrete-dark">
                    {t.location} · {t.service}
                  </p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        {/* We are still building our review base, so the section asks for one
            rather than pointing at a wall of them. */}
        <div className="mt-12 flex flex-col items-center text-center">
          <p className="max-w-xl text-concrete-dark">
            Worked with us? A few words on Google helps other Delaware
            homeowners know what to expect.
          </p>
          <CTAButton
            href={BUSINESS.reviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            variant="flame"
            size="lg"
            className="mt-6 rounded-none uppercase tracking-wide"
          >
            <Star className="h-5 w-5 fill-current" />
            Leave Us a Review
          </CTAButton>
        </div>
      </div>
    </section>
  );
}
